<template>
  <v-select
    v-model="item"
    :items="items"
    :rules="[rules.required]"
    :loading="isLoading"
    :error-messages="error"
    label="Área de atuação*"
    item-text="name"
    return-object
    clearable
    outlined
    dense
    @input="$emit('input', item)"    
  />
</template>

<script>
  import VehicleService from '@/services/vehicle.service';

  export default {
    name: 'VehicleOperationAreaSelect',
    
    props: {
      value: {
        type: Number,
        default: null
      },
    },

    data: () => ({
      isLoading: false,
      
      error: null,
      
      items: [],
      
      item: null,
      
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      },    
    }),

    mounted() {
      this.list();
    },
    methods: {
      list() {
        this.isLoading = true;
        VehicleService.listOperationAreas().subscribe(response => {
          this.items = response;
          this.isLoading = false;
        }, error => {
          this.error = 'Erro ao carregar as áreas de atuação';
          this.isLoading = false;
        });
      },
    },
  };
</script>